import { getCheckoutProductConfigurations, getConfigsWithSuiteIfPossible, getConfigurationsWithPBORequiredOnboarding, getHighestProductLevelInProductConfigurations, getIncludedCoreSeatsQuantity, getNonRecurringProductConfigurations, getOfferProductConfigurations, getProductConfigurationForSeats, getProductConfigurationWithFreeCoreSeatIfPossible, getProductLevelForCoreSeats, getProductLevelInConfigs, getProductsAndPacksForQueryParams, getProductVersionConfigsWithUnits, getSortedProductConfigurations, getSuiteProductConfigurations } from 'pricing-pages-lib/utils/productConfigUtils';
import { productForSkuIdSelector, skuSelector, productSelector } from './ProductsSelectors';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { QUANTITY_PACK } from 'self-service-api/constants/SkuTypes';
import { transformState } from './SelectorUtils';
export const configsWithSuiteIfPossibleSelector = createSelectorFromUtil(getConfigsWithSuiteIfPossible, transformState);
export const checkoutProductConfigurationsSelector = createSelectorFromUtil(getCheckoutProductConfigurations, transformState);
export const suiteProductConfigurationsSelector = createSelectorFromUtil(getSuiteProductConfigurations, transformState);
export const productLevelInConfigsSelector = createSelectorFromUtil(getProductLevelInConfigs, transformState);
export const configurationsWithPBORequiredOnboardingSelector = createSelectorFromUtil(getConfigurationsWithPBORequiredOnboarding, transformState);
export const offerProductConfigurationsSelector = createSelectorFromUtil(getOfferProductConfigurations, transformState);
export const nonRecurringProductConfigurationsSelector = createSelectorFromUtil(getNonRecurringProductConfigurations, transformState);
export const getFirstHubSkuIdFromProductConfigurations = (state, {
  productConfigurations
}) => {
  const foundProductConfig = productConfigurations.find(({
    skuId
  }) => {
    const {
      productLine,
      productLevel
    } = productForSkuIdSelector(state, {
      skuId
    });
    return productLine && productLevel;
  });
  if (!foundProductConfig) return 0;
  const foundSku = skuSelector(state, {
    skuId: foundProductConfig.skuId
  });
  let foundSkuId;
  const {
    skuType
  } = foundSku;
  if (skuType === QUANTITY_PACK) foundSkuId = foundSku.productVersionSkuId;else foundSkuId = foundSku.skuId;
  return foundSkuId;
};
export const productVersionConfigsWithUnitsSelector = createSelectorFromUtil(getProductVersionConfigsWithUnits, transformState);
export const productVersionFromConfigsSelector = (state, {
  productConfigurations,
  productLine
}) => {
  for (let i = 0; i < productConfigurations.length; i++) {
    const {
      productId,
      productVersionSkuId,
      skuId
    } = skuSelector(state, {
      skuId: productConfigurations[i].skuId
    });
    const {
      productLine: tempProductLine
    } = productSelector(state, {
      productId
    });

    if (tempProductLine === productLine) {
      // If the sku we selected is a quantity pack, it will have this field
      if (productVersionSkuId) {
        return skuSelector(state, {
          skuId: productVersionSkuId
        });
      }

      return skuSelector(state, {
        skuId
      });
    }
  }

  return null;
};
export const nonReccuringProductConfigurationsSelector = createSelectorFromUtil(getNonRecurringProductConfigurations, transformState);
export const highestProductLevelInProductConfigurations = createSelectorFromUtil(getHighestProductLevelInProductConfigurations, transformState);
export const productsAndPacksForQueryParamsSelector = createSelectorFromUtil(getProductsAndPacksForQueryParams, transformState);
export const productLevelForCoreSeatsSelector = createSelectorFromUtil(getProductLevelForCoreSeats, transformState);
export const includedCoreSeatsQuantitySelector = createSelectorFromUtil(getIncludedCoreSeatsQuantity, transformState);
export const productConfigurationWithFreeCoreSeatIfPossibleSelector = createSelectorFromUtil(getProductConfigurationWithFreeCoreSeatIfPossible, transformState);
export const productConfigurationForSeatsSelector = createSelectorFromUtil(getProductConfigurationForSeats, transformState);
export const sortedProductConfigurationsSelector = createSelectorFromUtil(getSortedProductConfigurations, transformState);